import { render, staticRenderFns } from "./StringsForCom.vue?vue&type=template&id=689cca94&scoped=true&"
import script from "./StringsForCom.vue?vue&type=script&lang=js&"
export * from "./StringsForCom.vue?vue&type=script&lang=js&"
import style0 from "./StringsForCom.vue?vue&type=style&index=0&id=689cca94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689cca94",
  null
  
)

export default component.exports